module.exports = __webpack_public_path__ + "images/insights-light-4a5ec9ca.png";